// import React, { useEffect, useRef } from "react";
// import ApexCharts from "apexcharts";
// import { formatNumberShort } from "../../../common/Validations";

// const POColumnChart = (props) => {
//   const chartRef = useRef(null);
//   // console.log(">> props ", props.chartdata);

//   let defaultSeries = [
//     {
//       name: "",
//       data: [],
//     },
//   ];
//   let defaultCategories = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];

//   const seriesData = props?.chartdata?.series || defaultSeries;
//   const categoriesData = props?.chartdata?.categories || defaultCategories;

//   useEffect(() => {
//     var options = {
//       series: seriesData,
//       chart: {
//         type: "bar",
//         height: 350,
//       },
//       plotOptions: {
//         bar: {
//           horizontal: false,
//           columnWidth: "80%",
//           borderRadius: 5,
//           borderRadiusApplication: "end",
//           dataLabels: {
//             position: 'top', // top, center, bottom
//           },
//         },
//       },
//       dataLabels: {
//         enabled: true,
//         formatter: function (val) {
//           return formatNumberShort(val) !== "0.00" ? formatNumberShort(val) : "";
//         },
//         offsetY: -20,
//         style: {
//           fontSize: '9px',
//           colors: ["#304758"]
//         }
//       },
//       stroke: {
//         show: true,
//         width: 2,
//         colors: ["transparent"],
//       },
//       xaxis: {
//         categories: categoriesData,
//       },
//       // yaxis: {
//       //   title: {
//       //     text: "$ (thousands)",
//       //   },
//       // },
//       fill: {
//         opacity: 1,
//       },
//       tooltip: {
//         y: {
//           formatter: function (val) {
//             // return "$ " + val + " thousands";
//             return "" + formatNumberShort(val);
//           },
//         },
//       },
//     };

//     const chart = new ApexCharts(chartRef.current, options);

//     chart.render();

//     return () => {
//       chart.destroy();
//     };

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [props?.chartdata]);

//   return <div id={`columnChart-${props?.key}`} ref={chartRef}></div>;
  
// };

// export default POColumnChart;

import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";
import { formatNumberShort } from "../../../common/Validations";

const POColumnChart = (props) => {
  const chartRef = useRef(null);

  const defaultCategories = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];

  // ✅ Normalize + align data with categories (IMPORTANT)
  const normalizeSeries = (series, categories) => {
    // Case 1: single number
    if (typeof series === "number") {
      return [{ name: "", data: categories.map(() => series) }];
    }

    // Case 2: array of numbers but length mismatch
    if (Array.isArray(series) && typeof series[0] === "number") {
      return [{
        name: "",
        data: categories.map((_, i) => series[i] ?? 0),
      }];
    }

    // Case 3: valid series but data length mismatch
    if (Array.isArray(series) && series[0]?.data) {
      return series.map((s) => ({
        ...s,
        data: categories.map((_, i) => s.data[i] ?? 0),
      }));
    }

    return [{ name: "", data: categories.map(() => 0) }];
  };

  const categoriesData =
    props?.chartdata?.categories?.length > 0
      ? props.chartdata.categories
      : defaultCategories;

  const seriesData = normalizeSeries(
    props?.chartdata?.series,
    categoriesData
  );

  useEffect(() => {
    if (!chartRef.current) return;

    const options = {
      series: seriesData,
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "80%",
          borderRadius: 5,
          borderRadiusApplication: "end",
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) =>
          val > 0 ? formatNumberShort(val) : "",
        offsetY: -20,
        style: {
          fontSize: "9px",
          colors: ["#304758"],
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: categoriesData,
      },
      tooltip: {
        y: {
          formatter: (val) => formatNumberShort(val),
        },
      },
    };

    const chart = new ApexCharts(chartRef.current, options);
    chart.render();

    return () => chart.destroy();
     // eslint-disable-next-line
  }, [props?.chartdata]);

  return <div ref={chartRef}></div>;
};

export default POColumnChart;
